export default "__VITE_ASSET__9ed100ab__"